export default "__VITE_ASSET__DP44lB5W__"